import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
var MountEventComponent = /*#__PURE__*/function (_Component) {
  _inherits(MountEventComponent, _Component);
  var _super = _createSuper(MountEventComponent);
  function MountEventComponent() {
    _classCallCheck(this, MountEventComponent);
    return _super.apply(this, arguments);
  }
  _createClass(MountEventComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var analyticsEvent = this.props.createAnalyticsEvent({
        action: 'mounted'
      });
      if (this.props.onMount) {
        this.props.onMount(analyticsEvent);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return MountEventComponent;
}(Component);
var MountEventComponentWithHOC = withAnalyticsEvents()(MountEventComponent);
export var MountEvent = function MountEvent(props) {
  return /*#__PURE__*/React.createElement(MountEventComponentWithHOC, props);
};